export enum DisplayMode {
  COMPACT = 'compact',
  EXPANDED = 'expanded'
}

export interface VitalSignsDisplayMode {
  display: DisplayMode
}
